<template>
  <b-alert show variant="danger" class="w-auto" :class="{ 'inline-block' : !full }">
    <h5 class="alert-heading">
      {{ title || $t('general.errorTitle') }}
    </h5>
    <p v-if="name">
      {{ $t('general.errorMessageName', { name: name }) }}
    </p>
    <p v-else>
      {{ message || $t('general.errorMessage') }}
    </p>
  </b-alert>
</template>

<script>
export default {
  name: 'BError',
  props: {
    name: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    full: {
      type: Boolean,
      default: true
    }
  }
}
</script>
